import React, { createContext, useState, useEffect, useCallback } from "react";
import { getDischargedPatients } from "../services/getDischargedPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const DischargedContext = createContext();

const INITIAL_FILTERS = {
  cipId: null,
  locationId: null,
  searchName: null,
  dateOfBirth: null,
  minLace: null,
  onlyOverdue: null,
  followUpStatusId: null,
  dateFrom: null,
  dateTo: null,
};

export const DischargedProvider = ({ children }) => {
  const [dischargedPatients, setDischargedPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const { isValid, authLoading } = useValidToken();

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => setFilters(INITIAL_FILTERS), []);

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);
      try {
        const data = await getDischargedPatients(filters);
        setDischargedPatients(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, filters]);

  return (
    <DischargedContext.Provider
      value={{
        dischargedPatients,
        loading,
        error,
        filters,
        updateFilter,
        resetFilters,
      }}
    >
      {children}
    </DischargedContext.Provider>
  );
};
